<script>
    import { createEventDispatcher } from 'svelte';
    import { currentPage } from './store';
    import { get } from 'svelte/store';
    import { slide, fade } from 'svelte/transition';

    const dispatch = createEventDispatcher();

    let isMenuOpen = false;
    let previousPage = '';

    function navigateTo(page) {
        currentPage.set(page);
    }

    function handleKeyDown(event) {
        if (event.key === 'Enter' || event.key === ' ') {
            dispatch('click', { detail: 'menu' });
        }
    }

    function handleMenuItemClick(page) {
        navigateTo(page);
        isMenuOpen = false;
    }

    function toggleMenu() {
      if (isMenuOpen) {
        navigateTo(previousPage);
      } else {
        previousPage = get(currentPage);
        navigateTo('');
      }
        isMenuOpen = !isMenuOpen;
    }

</script>

<header class="mb-5 absolute w-full flex flex-col justify-center top-0 left-0 p-6">
    <div class="flex items-center justify-end gap-3">
        <button 
            class="p-2 text-stone-900 rounded-lg border-none" 
            on:click={toggleMenu} 
            on:keydown={handleKeyDown}
            aria-label="Toggle menu"
        >
            {#if isMenuOpen}
                <!-- 'X' Icon -->
                <svg class="w-10 h-10" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M18 6L6 18M6 6l12 12"/>
                </svg>
            {:else}
                <!-- Menu Icon -->
                <svg class="w-10 h-10" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M3 12h18M3 6h18M3 18h18"/>
                </svg>
            {/if}
        </button>
    </div>
    {#if isMenuOpen}
      <div class="flex flex-col justify-center h-full">
        <div out:fade={{duration:500}} class="pt-2 space-y-4 sm:px-3 text-6xl lg:text-9xl">
          <a in:slide={{delay:500,duration:700}} on:click={() => handleMenuItemClick('home')} href="#" class="block py-3">Home</a>
          <a in:slide={{delay:700,duration:700}} on:click={() => handleMenuItemClick('projects')} href="#" class="block py-3">Projects</a>
          <a in:slide={{delay:900,duration:700}} on:click={() => handleMenuItemClick('skills')} href="#" class="block py-3">Skills</a>
          <a in:slide={{delay:1100,duration:700}} on:click={() => handleMenuItemClick('contact')} href="#" class="block py-3">Contact</a>
        </div>
      </div>
    {/if}
</header>

<style>
    /* Your styles here */
</style>